var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("w-input", {
        attrs: { value: _vm.inputText, label: _vm.label, fancy: "" },
        on: {
          focus: function ($event) {
            return _vm.openModal()
          },
        },
      }),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.modalOpen,
            callback: function ($$v) {
              _vm.modalOpen = $$v
            },
            expression: "modalOpen",
          },
        },
        [
          _vm.modalOpen
            ? _c(
                "w-card",
                { attrs: { "max-width": "500" } },
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("use-field")))]),
                  _c("app-column-select", {
                    attrs: {
                      label: _vm.label,
                      model: _vm.model,
                      "is-server-column": "",
                    },
                    model: {
                      value: _vm.modalValue,
                      callback: function ($$v) {
                        _vm.modalValue = $$v
                      },
                      expression: "modalValue",
                    },
                  }),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "cancel",
                          attrs: { icon: "ban" },
                          on: {
                            click: function ($event) {
                              _vm.modalOpen = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: { icon: "save" },
                          on: {
                            click: function ($event) {
                              return _vm.setModalValue()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }